<template>
  <div :class="flexDir" class="flex relative justify-between">
    <div @click="closeMe" class="absolute top-0 right-0 cursor-pointer w-6 h-6 mt-1 mr-1 z-50 text-gray-400 hover:text-black text-smaller">
      <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
        <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
      </svg>
    </div>
    <div :class="{'md:w-72': !isForestSquares, 'md:pt-0': !isForestSquares }" class="relative flex flex-col justify-end bg-gray-100 z-10 pr-8 pl-6 pb-4 pt-8">
      <div :class="showPreview" class="h-full justify-center items-center text-gray-400">
        <div class="md:mb-6" key="shoppingcart" v-if="shoppingCart.length > 1 || !shoppingCart.length">
        </div>
        <img :key="preview" v-else-if="preview" :src="preview" class="h-72">
        <div :key="loading" v-else class="flex flex-col items-center justify-center h-72">
          <span class="">Laddar produktbild...</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="fill-current" width="50" height="50" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" display="block"><rect x="47" y="27" rx="3" ry="3" width="6" height="6"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(30 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(60 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(90 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(120 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(150 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(180 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(210 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(240 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(270 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(300 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(330 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/></rect></svg>
        </div>
      </div>
      <div :key="idx" v-for="(item, idx) in shoppingCartItems" class="">
        <div class="flex justify-between">
          <div>{{item.title}}</div>
          <div class="flex items-baseline">
            <span v-if="priceUnit != 'sum'">{{ numItems(item) }} <span class="text-sm text-gray-600">&#x00D7;</span> </span>{{ item.price }} kr
            <svg @click="removeItem(idx)" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="fill-current text-gray-500 hover:text-gray-900 w-3 h-3 ml-2 -mr-5 cursor-hand"><path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z"></path></svg>
          </div>
        </div>
        <div v-if="!isForestSquares" class="-mt-1 text-sm text-gray-500">{{item.to}}</div>
      </div>
      <div v-if="print && !isForestSquares" class="flex justify-between mt-1">
        <div>
          <span>Utskrift</span>
        </div>
        <div><span v-if="shoppingCartItems.length > 1">{{ shoppingCartItems.length}} <span class="text-sm text-gray-600">&#x00D7;</span> </span>{{ printFee }} kr</div>
      </div>
      <div class="flex justify-between items-baseline mt-6">
        <div class="font-semibold uppercase">Summa</div>
        <div class="font-semibold text-2xl whitespace-no-wrap pl-4 border-t border-black">{{ sum }} kr</div>
      </div>
    </div>

    <div :class="{'md:w-72': !isForestSquares}" class="relative flex-grow mx-5">
      <transition :name="slideDirection">
        <slot name="prePaymentStep"></slot>
        <div class="h-full" key="pay" v-if="showPayment">
          <h3 class="pt-4 mb-3 text-left text-lg">
            Välj betalsätt
          </h3>
          <div class="flex">
            <button
              type="button" 
              class="btn-sm shadow-sm px-3 py-1 normal-case text-smaller md:text-base"
              :class="activePaymentMethodClass('swish')"
              @click="selectedPaymentMethod = 'swish'"
            >Swish</button>
            <button
              type="button" 
              class="btn-sm ml-4 shadow-sm px-3 py-1 normal-case text-smaller md:text-base"
              :class="activePaymentMethodClass('card')"
              @click="selectedPaymentMethod = 'card'"
            >Betalkort</button>
            <button
              type="button" 
              class="btn-sm ml-4 shadow-sm px-3 py-1 normal-case text-smaller md:text-base"
              :class="activePaymentMethodClass('invoice')"
              @click="selectedPaymentMethod = 'invoice'"
            >Faktura</button>
          </div>
          <ValidationObserver v-slot="{ invalid }">
            <div v-if="selectedPaymentMethod == 'invoice'" class="mt-2">
              <span class="text-sm text-gray-500">Betalning mot faktura innebär att du får ditt gåvobevis först när vi mottagit betalningen.</span>
            </div>
            <div v-if="!isForestSquares" class="mt-2">
              <input type="checkbox" class="appearance-none text-nagreen na-checkbox" id="leverans" v-model="print"/>
              <label for="leverans" class="ml-1 text-nagreen text-base tracking-tight">Lägg till utskrift och leverans +{{printFee}} kr<span v-if="shoppingCartItems.length > 1">/st</span></label>
            </div>
            <div class="mt-2">
              <TextInput v-model="name" name="Namn" type="text" rules="required" placeholder="Namn"></TextInput>
            </div>
            <div v-if="selectedPaymentMethod == 'card'" class="mt-2">
              <StripeCard
                :amount="sum"
                :name="name"
                :email="email"
                ref="card"
                @confirmCardSuccess="confirmCardSuccess"
                @confirmCardFailure="confirmCardFailure"></StripeCard>
            </div>
            <div v-else-if="selectedPaymentMethod == 'swish'" class="mt-2">
              <TextInput v-model="phone" leftLogo="/wp-content/themes/naturarvet-2.0/assets/img/swish-logo.png" name="Ange ditt nummer kopplat till Swish" :customMessages="{ 'required': 'Ange ditt telefonnummer' }" type="tel" rules="required|tel" placeholder="Telefonnummer"></TextInput>
            </div>
            <div class="mt-2">
              <TextInput v-model="email" name="Email" type="email" autocomplete="email" rules="required|email" placeholder="E-post"></TextInput>
            </div>
            <transition name="fade">
              <div v-if="print">
                <div class="pt-2 text-center border-b-2 leading-1 mt-4 mb-6">
                  <span class="bg-white px-4 text-gray-700 text-smaller">Leveransadress</span>
                </div>
                <div class="mt-2 flex-1">
                  <TextInput v-model="receiverName" name="Mottagarnamn" subLabel="- om annan än köparen" type="text" placeholder="Motagarnamn"></TextInput>
                </div>
                <div class="mt-2">
                  <TextInput v-model="streetAddress" name="Gatuadress" type="text" rules="required" placeholder="Gatuadress"></TextInput>
                </div>
                <div class="mt-2 flex">
                  <div class="w-32">
                    <TextInput v-model="postalCode" name="Postnummer" type="tel" rules="required|postalCode" placeholder="Postnummer"></TextInput>
                  </div>
                  <div class="ml-2 flex-grow">
                    <TextInput v-model="city" name="Ort" type="text" rules="required" placeholder="Ort"></TextInput>
                  </div>
                </div>
              </div>
            </transition>
            <div class="mt-2">
              <input type="checkbox" id="company" v-model="company">
              <label for="company" class="company-label ml-2 text-gray-500">Företag</label>
            </div>
            <div v-if="company" class="mt-2 mb-2">
              <TextInput v-model="orgNum"
                         name="Organisationsnummer"
                         type="tel"
                         rules="required|numeric|length:10"
                         placeholder="Organisationsnummer"
                         :maxlength="10"
                         :customMessages="{ 'length': 'Ange organisationsnummer med 10 siffror', 'numeric': 'Ange organisationsnummer med enbart siffror', 'required': 'Ange organisationsnummer' }"
               ></TextInput>
            </div>
            <div>
              <input type="checkbox" id="newsletterSignup" v-model="newsletterSignup">
              <label for="newsletterSignup" class="company-label ml-2 text-gray-500">Jag vill ha Naturarvets nyhetsbrev</label>
            </div>
            <div class="flex flex-col items-center my-4">
              <span v-if="error" class="text-error block bg-red-100 rounded p-2 mb-1">{{ error }}</span>
              <button type="button" :disabled="invalid || loading || !shoppingCartItems.length" class="btn bg-nagreen-light text-white hover:bg-nagreen normal-case relative my-0 px-12" @click="purchase">Slutför<div :class="[ loading ? 'inline-block' : 'hidden' ]" class="lds-dual-ring absolute inset-y-0 inset-x-0 mx-auto w-8 h-8"></div></button>
            </div>
          </ValidationObserver>
        </div>
        <div v-if="openSwish" key="openApp" class="h-full items-center justify-center flex flex-col">
          <img src="/wp-content/themes/naturarvet-2.0/assets/img/swish-logotype.svg" class="w-40 h-20 mt-8">
          <div class="mt-8 mb-4 text-center max-w-full">Öppna din Swish-app för att slutföra din betalning.</div>
          <div class="lds-dual-ring mt-4"></div>
          <button type="button" class="btn btn-border mb-4 py-1 px-3 normal-case" @click="cancelSwish">Avbryt</button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import StripeCard from './StripeCard.vue'
  import TextInput from './TextInput.vue'
  import { ValidationObserver } from 'vee-validate'
  import differenceInMinutes from 'date-fns/differenceInMinutes'
  import Bugsnag from '@bugsnag/js'

  export default {
    components: {
      TextInput, StripeCard, ValidationObserver
    },
    data() {
      return {
        company: false,
        print: false,
        ssn: undefined,
        orgNum: undefined,
        printFee: 75, // TODO: Take this as prop instead
        loading: false,
        name: '',
        email: '',
        receiverName: '',
        streetAddress: '',
        postalCode: '',
        city: '',
        phone: undefined,
        timer: undefined,
        openSwish: false,
        swishId: undefined,
        timeWaitedForSwish: undefined,
        swishError: undefined,
        cardError: undefined,
        selectedPaymentMethod: 'swish',
        slideDirection: 'slide-left',
        generalError: undefined,
        paymentShownAt: undefined,
        shoppingCartItems: [],
        newsletterSignup: false,
      }
    },
    created() {
      this.shoppingCartItems = this.isForestSquares || !this.shoppingCart ? [{
        title: this.title,
        numItems: this.numItems(),
        price: this.price,
        to: this.to,
        from: this.isForestSquares ? this.from : null,
        message: this.isForestSquares ? null : this.message,
        productId: this.isForestSquares ? null : this.productId,
        numTrees: this.isForestSquares ? null : this.numTrees,
        greeting: this.greeting ? (this.greeting.pdfLabel || this.greeting.label) : '',
      }] : this.shoppingCart
    },
    computed: {
      showPayment() {
        return this.prePaymentStepDone && !this.openSwish
      },
      sum() {
        return this.isForestSquares ?
          this.forestSquares.length * this.price :
          this.shoppingCartItems.reduce((sum, item) => {
            return sum + parseInt(item.numItems || item.numTrees) * parseInt(item.price)
        }, 0) + (this.print ? this.printFee * this.shoppingCartItems.length : 0)
      },
      error() {
        if (this.generalError) {
          return this.generalError
        }
        return this.selectedPaymentMethod == 'card' ? this.cardError : this.swishError
      },
      flexDir() {
        return this.isForestSquares ? "flex-col" : "flex-col md:flex-row"
      },
      showPreview() {
        return this.isForestSquares ? "hidden" : "hidden md:flex"
      },
      isForestSquares() {
        return this.type == "forestSquare"
      },
    },
    watch: {
      prePaymentStepDone(newVal, oldVal) {
        this.paymentShownAt = !oldVal && newVal ? new Date() : undefined
        if (!oldVal && newVal) {
          this.shoppingCartItems =  [{
            title: this.title,
            numItems: this.numItems(),
            price: this.price,
            to: this.to,
            from: this.from,
            message: null,
            productId: null,
            numTrees: null,
            greeting: '',
          }]
        }
      },
    },
    methods: {
      removeItem(index) {
        this.shoppingCartItems.splice(index, 1)
        this.$root.$emit('addToShoppingCart', -1)
        if (this.shoppingCart && this.shoppingCart.length) {
          localStorage.setItem('shoppingCart', JSON.stringify(this.shoppingCartItems))
          if (this.shoppingCart.length == 1) {
            this.$emit('generatePreviewFor', this.shoppingCart[0])
          }
        } else {
          localStorage.removeItem('shoppingCart')
        }

      },
      numItems(item) {
        return this.forestSquares ? this.forestSquares.length : (item ? item.numTrees : this.numTrees)
      },
      async cancelSwish() {
        await axios.delete(`/wp-json/naturarvet/v1/swishPurchase/${this.swishId}`)
        this.slideDirection = 'slide-right'
        this.openSwish = false
        this.loading = false
        clearTimeout(this.timer)
      },
      closeMe() {
        this.$emit('close')
      },
      async purchase() {
        if (this.paymentTimeout > 0
          && differenceInMinutes(new Date(), this.paymentShownAt) > this.paymentTimeout) {
          this.generalError = 'Köpet slutfördes inte i tid. Ladda om sidan och försök igen.'
          return
        }
        this.swishError = ''
        this.cardError = ''
        this.loading = true
        if (this.selectedPaymentMethod == 'card') {
          try {
            const { data: { clientSecret, stripeCustomer } } = await axios.post(
              '/wp-json/naturarvet/v1/cardPurchase',
              await this.purchaseParams()
            )
            this.$refs.card.confirmCard(clientSecret, stripeCustomer)
          } catch (e) {
            Bugsnag.notify(e)
            this.loading = false
            this.cardError = "Något gick fel när ditt kreditkort skulle användas. Vänligen försök igen eller kontakta givarservice på 070-648 47 89."
          }
        } else if (this.selectedPaymentMethod == 'invoice') {
          try {
            const { data: { pdf, orderId } } = await axios.post(
              '/wp-json/naturarvet/v1/invoicePurchase',
              await this.purchaseParams()
            )
            this.$emit('success', { email: this.email, print: this.print, orderId, pdf})
          } catch (e) {
            Bugsnag.notify(e)
            this.loading = false
            this.cardError = "Något gick fel när vi skulle skapa din faktura. Vänligen försök igen eller kontakta givarservice på 070-648 47 89."
          }
        } else { // Swish payment
          this.slideDirection = 'slide-left'
          this.openSwish = true
          this.timeWaitedForSwish = 0
          try {
            const { data } = await axios.post(
              '/wp-json/naturarvet/v1/swishPurchase',
              {
                ...(await this.purchaseParams()),
                phone: this.phone,
              }
            )
            if (!data.id) {
              this.hideSwish("Kunde inte starta Swish betalningen, försök igen eller välj ett annat betalsätt.")
              return
            }
            this.swishId = data.id
            this.timer = setTimeout(this.swishStatus, 1000)
          } catch(e) {
            Bugsnag.notify(e)
            this.hideSwish(e.response && e.response.data.message ?
              e.response.data.message :
              "Kunde inte starta Swish betalningen, försök igen eller välj ett annat betalsätt."
            )
          }
        }
      },
      hideSwish(message) {
        this.slideDirection = 'slide-right'
        this.loading = false
        this.openSwish = false
        this.swishError = message;
      },
      async swishStatus() {
        try {
          this.timeWaitedForSwish = this.timeWaitedForSwish + 1
          if (this.timeWaitedForSwish >= 60*3) {
            this.hideSwish("Swish betalningen hann inte bli klar i tid. Försök igen eller välj ett annat betalsätt.")
            return
          }
          const { data } = await axios.get(`/wp-json/naturarvet/v1/swishStatus/${this.swishId}`)
          if (data.status == 'CREATED' && this.openSwish) {
            this.timer = setTimeout(this.swishStatus, 1000)
            return
          }
          if (data.status == 'PAID') {
            this.$emit('success', { email: this.email, print: this.print, orderId: data.orderId })
            return
          }
          if (data.status == 'DECLINED') {
            this.hideSwish("Swish betalningen avvisades. Försök igen eller välj ett annat betalsätt.")
          } else {
            this.hideSwish(data.message ||
              "Något gick fel, försök igen eller kontakta givarservice på 070-648 47 89")
          }
        } catch (e) {
          Bugsnag.notify(e)
          this.hideSwish("Något gick fel, försök igen eller kontakta givarservice på 070-648 47 89")
        }
      },
      async purchaseParams() {
        return {
          email: this.email,
          name: this.name,
          amount: this.sum,
          items: this.shoppingCartItems,
          print: this.print,
          receiverName: this.receiverName,
          address: this.streetAddress,
          postalCode: this.postalCode,
          city: this.city,
          orgNum: this.orgNum,
          forestSquares: this.forestSquares,
          forestSquareOrderId: this.orderId,
          forestSquareMapId: this.mapId,
          newsletterSignup: this.newsletterSignup,
          testmode: this.testmode,
        }
      },
      async confirmCardSuccess({ paymentIntent }) {
        try {
          const resp = await axios.put(
            '/wp-json/naturarvet/v1/cardPurchase',
            {
              paymentIntentId: paymentIntent.id,
            }
          )
          this.loading = false
          this.$emit('success', { email: this.email, print: this.print, orderId: resp.data.orderId })
        } catch (e) {
          this.loading = false
          Bugsnag.notify(e)
          this.cardError = "Något gick fel, försök igen eller kontakta givarservice på 070-648 47 89"
        }
      },
      confirmCardFailure(message) {
        this.loading = false
        this.cardError = message
      },
      activePaymentMethodClass(method) {
        return this.selectedPaymentMethod == method ?
          [ 'btn-primary' ] : [ 'btn-border', 'hover:bg-gray-200' ]
      },
    },
    props: { 
      shoppingCart: {
        type: Array,
        default: () => []
      },
      productId: Number,
      title: String,
      numTrees: Number,
      price: Number,
      greeting: Object,
      to: String,
      from: String,
      message: String,
      preview: String,
      type: String,
      forestSquares: Array,
      prePaymentStepDone: {
        type: Boolean,
        default: true,
      },
      mapId: Number,
      orderId: Number,
      paymentTimeout: {
        type: Number,
        default: 0
      },
      testmode: Boolean,
      priceUnit: String,
    },
  }
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: opacity .2s ease;
}
.fade-leave-active {
  transition: opacity .2s ease-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}
input:checked ~ .company-label {
  @apply text-gray-800;
}
</style>

